const setImageUrl = mainImage => url => mainImage.src = url ? url : mainImage.src;

export default setImageUrl